import React from "react";

// Declarar y exportar el componente al mismo tiempo
export default function BtnFiltrar(props) {
  return (
    // Funcion para detectar el click en el boton, usa la function de useState de App para modificar el nombre de filtro por el seleccionado
    // Posteriormente entra el prop estaPresionado que va a evaluar si el nombre actual para ver si coincide con el de filtro, si es true mantiene el aria-pressed
    <button type = "button" className = "btn toggle-btn" onClick = {() => props.editarFiltro(props.nombre)} aria-pressed = {props.estaPresionado}>
      <span className = "visually-hidden">Mostrar </span>
      <span>{props.nombre}</span>
      <span className = "visually-hidden"> las tareas</span>
    </button>
  );
}  